/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef } from "react";
const Slider = require("react-slick").default;
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { OrangeTextButton } from "../../common/OrangeTextButton";

export const SMTPPhotoSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<any>(null);
  const { selectedClipSMTPMedia } = useClipsStore();

  const handleDownload = (media: any) => {
    if (media.url) {
      const link = document.createElement("a");
      link.href = media.url;
      link.download = media.filename || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => setCurrentSlide(next),
  };

  let mediaWithURLs = 0;

  selectedClipSMTPMedia.forEach((media: any) => {
    if (media.url) {
      mediaWithURLs++;
    }
  });

  const totalSlides = mediaWithURLs; // Since you have 3 slides

  return (
    <div
      style={{ position: "relative", display: "flex", flexDirection: "column" }}
    >
      {/* Custom dots absolutely positioned above the slider */}
      {totalSlides > 1 && (
        <div
          style={{
            position: "absolute",
            top: "-25px",
            left: "50%",
            transform: "translateX(-170%)",
            zIndex: 10,
            display: "flex",
            gap: "10px",
          }}
        >
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                border: "none",
                backgroundColor: currentSlide === index ? "#333" : "#ccc",
                cursor: "pointer",
                padding: "0",
                margin: "0",
              }}
              onClick={() => {
                setCurrentSlide(index);
                sliderRef.current?.slickGoTo(index);
              }}
            />
          ))}
        </div>
      )}

      <Slider ref={sliderRef} {...settings}>
        {selectedClipSMTPMedia.map((media: any, index: number) =>
          media.filename.includes("jpg") && media.url ? (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img width="450" src={media.url} alt="clip" />
              <div style={{ marginTop: "10px" }}>
                <OrangeTextButton
                  onClick={() => handleDownload(media)}
                  text="Download Image"
                  disabled={false}
                />
              </div>
            </div>
          ) : (media.filename.includes("mp4") ||
              media.filename.includes("mkv")) &&
            media.url ? (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <video
                width="450"
                autoPlay
                controls
                loop
                onError={(e) => {
                  console.error("Video playback error:", e);
                }}
              >
                {media.filename.includes("mkv") ? (
                  <>
                    {/* Try multiple MIME types for MKV - browser will use first supported one */}
                    <source src={media.url} type="video/x-matroska" />
                    <source src={media.url} type="video/mkv" />
                    {/* Fallback: let browser try without type specification */}
                    <source src={media.url} />
                  </>
                ) : (
                  <source src={media.url} type="video/mp4" />
                )}
                Your browser does not support the video tag or this video
                format.
              </video>
              <div style={{ marginTop: "10px" }}>
                <OrangeTextButton
                  onClick={() => handleDownload(media)}
                  text="Download Video"
                  disabled={false}
                />
              </div>
            </div>
          ) : null
        )}
      </Slider>
    </div>
  );
};
